import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "text-center text-slate-700 text-lg mb-4"
};
const _hoisted_2 = {
  class: "relative"
};
const _hoisted_3 = {
  class: "-mx-7"
};
const _hoisted_4 = {
  key: 0,
  class: "text-center text-red-600 text-lg mt-4"
};
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
import SubstitutionPlayerRow from "@/modules/match/components/SubstitutionPlayerRow.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'SubstitutionDialog',
  props: {
    match: null,
    liveMatchEvaluator: null
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const dialog = ref(null);
    const show = async () => {
      form.value = {};
      try {
        await dialog.value.confirm();
      } catch (e) {
        return {};
      }
      const result = {};
      Object.keys(form.value).forEach(k => {
        if (form.value[k] !== null) {
          result[k] = form.value[k];
        }
      });
      return result;
    };
    const form = ref({});
    const substitutionsCount = computed(() => Object.keys(form.value).filter(k => form.value[k] !== null).length);
    const onUpdateSelected = (playerId, selectedPlayerId) => {
      Object.keys(form.value).forEach(playerId => {
        if (form.value[playerId] === selectedPlayerId) {
          form.value[playerId] = null;
        }
      });
      form.value[playerId] = selectedPlayerId;
    };
    const team = computed(() => props.match.homeTeam.user ? props.match.homeTeam : props.match.awayTeam);
    const linedupPlayers = computed(() => collect(team.value.players).where('lineup', '!==', null).sortBy('lineup').toArray());
    const confirm = () => {
      close();
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(RichDialog, {
        ref_key: "dialog",
        ref: dialog,
        "confirmation-disabled": __props.liveMatchEvaluator.substitutionLeft < _unref(substitutionsCount)
      }, {
        title: _withCtx(() => [_createVNode(EntityLink, {
          entity: _unref(team),
          disabled: ""
        }, null, 8, ["entity"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('x_substitutions_left', {
          x: __props.liveMatchEvaluator.substitutionLeft
        })), 1), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(linedupPlayers), player => {
          return _openBlock(), _createBlock(SubstitutionPlayerRow, {
            key: player.id,
            "selected-player-id": form.value[player.id],
            "onUpdate:selected-player-id": $event => form.value[player.id] = $event,
            match: __props.match,
            player: player,
            team: _unref(team),
            "substituted-player-ids": __props.liveMatchEvaluator.substitutedPlayerIds,
            suspended: __props.liveMatchEvaluator.suspendedPlayerIds.includes(player.id),
            class: "text-sm p-2 py-0.5 mb-1 last:mb-0 even:bg-slate-50",
            "onUpdate:selectedPlayerId": $event => onUpdateSelected(player.id, $event)
          }, null, 8, ["selected-player-id", "onUpdate:selected-player-id", "match", "player", "team", "substituted-player-ids", "suspended", "onUpdate:selectedPlayerId"]);
        }), 128))])]), __props.liveMatchEvaluator.substitutionLeft < _unref(substitutionsCount) ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('too_many_substitutions')), 1)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["confirmation-disabled"]);
    };
  }
});